/**
 * The permission vocabulary itself. Nothing here depends on anything else, so
 * the endpoints and pages that only need to name a permission can stop at this
 * file rather than pulling in the whole catalogue.
 */
export enum AdminUserPermissions {
  super_admin = "super_admin",
  view_staff_notes = "view_staff_notes",
  post_staff_notes = "post_staff_notes",
  post_staff_timeline = "post_staff_timeline",
  manage_venues = "manage_venues",
  manage_users = "manage_users",
  kanban_board = "kanban_board",
}
export enum SocietyAdminPermissions {
  settings = "settings",
  forms = "forms",
  profiles = "profiles",
  groups = "groups",
  accounting = "accounting",
  chatbot = "chatbot",
  submissions = "submissions",
  reviews = "reviews",
  reviews_edit = "reviews_edit",
  review_session_member_delete = "review_session_member_delete",
  reviews_manual_assignment = "reviews_manual_assignment",
  conference = "conference",
  delete_conference = "delete_conference",
  reports = "reports",
  notifications = "notifications",
  dashboard_page = "dashboard_page",
  modify_payments = "modify_payments",
  modify_payments_advanced = "modify_payments_advanced",
  basic_refunds = "basic_refunds",
  list_invoices = "list_invoices",
  list_invoice_items = "list_invoice_items",
  deferement_length = "deferement_length",
  deferement_range = "deferement_range",
  list_payments = "list_payments",
  list_payment_items = "list_payment_items",
  discount = "discount",
  delete_discount_code = "delete_discount_code",
  group_members = "group_members",
  submission_definitions = "submission_definitions",
  submission_instances = "submission_instances",
  profiles_overview = "profiles_overview",
  profiles_accounting = "profiles_accounting",
  profiles_education = "profiles_education",
  profiles_communication = "profiles_communication",
  profiles_files = "profiles_files",
  profiles_tags = "profiles_tags",
  profiles_groups = "profiles_groups",
  profiles_accounting_invoice = "profiles_accounting_invoice",
  profile_delete = "profile_delete",
  profiles_membership = "profiles_membership",
  profiles_notes = "profiles_notes",
  manage_identity = "manage_identity",
  group_details = "group_details",
  settings_general = "settings_general",
  custom_question_choices = "custom_question_choices",
  settings_forms = "settings_forms",
  settings_communication = "settings_communication",
  settings_routes = "settings_routes",
  settings_directories = "settings_directories",
  settings_society_files = "settings_society_files",
  settings_products = "settings_products",
  settings_automated_tasks = "settings_automated_tasks",
  settings_automated_tasks_authorize_net = "settings_automated_tasks_authorize_net",
  settings_automated_tasks_profile_update = "settings_automated_tasks_profile_update",
  settings_tags = "settings_tags",
  settings_advanced = "settings_advanced",
  settings_aws = "settings_aws",
  settings_reference = "settings_reference",
  settings_reference_detail = "settings_reference_detail",
  settings_integrations = "settings_integrations",
  settings_integrations_billhighway = "settings_integrations_billhighway",
  settings_integrations_higherlogic = "settings_integrations_higherlogic",
  settings_integrations_memberplanet = "settings_integrations_memberplanet",
  submission_definition_advanced = "submission_definition_advanced",
  workflow_builder = "workflow_builder",
  workflow_builder_simple = "workflow_builder_simple",
  workflow_builder_advanced = "workflow_builder_advanced",
  workflow_instance_manage = "workflow_instance_manage",
  merge_profiles = "merge_profiles",
  report_edit = "report_edit",
  report_config = "report_config",
  workflow_instance_change_state = "workflow_instance_change_state",
  profile_notes_manage = "profile_notes_manage",
  profile_notes_delete = "profile_notes_delete",
}

/** Every permission an admin user can hold, global or society scoped. */
export type AdminPermissions = AdminUserPermissions | SocietyAdminPermissions;
